/** Shared UI vocabulary used across screens. */
export const common = {
  en: {
    "col.time": "Time",
    "col.session": "Session",
    "col.status": "Status",
    "col.event": "Event",
    "col.in": "In",
    "col.headline": "Headline",
    "col.impact": "Impact",
    "assetClass.stock": "Stock",
    "assetClass.etf": "ETF",
    "assetClass.crypto": "Crypto",
    "assetClass.fx": "Currency",
    "assetClass.metal": "Metal",
    "assetClass.commodity": "Commodity",
    "assetClass.index": "Index",
    "tf.1d": "Daily",
    "tf.4h": "4 hours",
    "tf.1h": "Hourly",
    "action.close": "Close",
    "action.cancel": "Cancel",
    "action.ok": "OK",
    "action.confirm": "Confirm",
    "common.working": "Working…",
    "disclaimer.short": "Chart tools and community voting, no investment advice. Past patterns do not guarantee future results.",
  },
  de: {
    "col.time": "Zeit",
    "col.session": "Sitzung",
    "col.status": "Status",
    "col.event": "Ereignis",
    "col.in": "In",
    "col.headline": "Meldung",
    "col.impact": "Wirkung",
    "assetClass.stock": "Aktie",
    "assetClass.etf": "ETF",
    "assetClass.crypto": "Krypto",
    "assetClass.fx": "Währung",
    "assetClass.metal": "Edelmetall",
    "assetClass.commodity": "Rohstoff",
    "assetClass.index": "Index",
    "tf.1d": "Täglich",
    "tf.4h": "4 Stunden",
    "tf.1h": "Stündlich",
    "action.close": "Schließen",
    "action.cancel": "Abbrechen",
    "action.ok": "OK",
    "action.confirm": "Bestätigen",
    "common.working": "Wird ausgeführt …",
    "disclaimer.short": "Chart-Werkzeuge und Community-Voting, keine Anlageberatung. Vergangene Muster garantieren keine künftigen Ergebnisse.",
  },
};
